/** Align applet content with the full-width shell header. */
export const APPLET_HORIZONTAL_PADDING = 'px-4 sm:px-12';
